@if(resultService!.results.type === 'final'){
  <div class="resultPageWrap">
    <div class="resultPageWrap-backButton-wrap">
      <back-button [routerLink]="route()"></back-button>
    </div>

    <div class="resultPage-result-wrap">
      @if(questionResult().answer === questionResult().allQuestion){
      <img  class="resultPage-result__image"   src="assets/icons/success-test.svg">
    }@else{
        <img  class="resultPage-result__image"   src="assets/icons/not-success.svg">
      }

      <h1 class="resultPage-result__title din-pro-condensed">Результат</h1>
      <h2 class="resultPage-result__title-result">
            {{questionResult()!.answer}}/{{questionResult().allQuestion}}
      </h2>
      @if(questionResult().answer! >= questionResult().correctAnswersCount!)
      {
        <p class="resultPage-result__text din-pro-simple-text">
          Вы успешно прошли итоговое тестирование
        </p>
      }@else{
        <p class="resultPage-result__text din-pro-simple-text ">
          Чуть-чуть не хватило.<br>
          Для сертификата необходимо набрать <span class=" resultPage-result__text red-color din-pro-simple-text not-success  ">13 баллов</span>. Попробуйте еще раз
          </p>
      }
    </div>

    <div class="resultPage-buttonWrap">
      <button  (click)="restartTest()" class="button ">Попробовать еще  раз </button>
      <button (click)="home()" class="button active">Завершить</button>
    </div>
  </div>
} @else{
  <div class="resultPageWrap">
    <div class="resultPageWrap-backButton-wrap">
        <div class="result-answer-wrap">
          <span class="result-page-answer din-pro-condensed">Ответы:</span><span class="result-page-answer din-pro-condensed">{{questionResult()!.answer}}/{{questionResult().allQuestion}}</span>
        </div>

    </div>
    <div class="testing-page-question-wrap">
      @for (modile of dinamicData(); track modile) {
        <div class="wrap-qa">
          <h1 class="testing-page-question__title din-pro-condensed">
            {{ modile.title }}
          </h1>
          <div class="testing-page-question__form">
            @for (item of modile.options; track item.id) {
              <div class="testing-wrap-items">

              <span class="course-answer-item din-pro-simple-text">
          {{ item.label }}
        </span>
                @if (resultService!.results[item.controlName] === item.value) {
                  <span class="course-answer-item   answer din-pro-simple-text  "
                        [style.color]=" resultService!.results[item.controlName] === modile.correct ?   '#43BE00' : 'rgba(230, 0, 0, 1)' ">
            {{resultService!.results[item.controlName] === modile.correct ? 'Верно' : 'Неверно' }}
          </span>
                }
                @else if (
                  resultService!.results[item.controlName] !== '' && resultService!.results[item.controlName] !== item.value && item.value === modile.correct) {
                  <span class="course-answer-item answer din-pro-simple-text  " style="color: #43BE00;">Верно</span>
                }
              </div>
            }
          </div>
        </div>
      }

    </div>
    <div class="resultPage-buttonWrap intermediate ">
      <button  (click)="home()" class="button button-with-arrow" >Вернуться к курсу  </button>
    </div>
  </div>
}
